import React, { createRef, Component } from "react";
import { get as _get, isEmpty as _isEmpty, isEqual as _isEqual } from "lodash";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import DateRangePickerTmp from "react-bootstrap-daterangepicker";
import moment from "moment";

class DateRangePicker extends Component {

  constructor(props) {
    super(props);

    const { appConstants: { dateRangeOptions } } = props;

    this.state = {
      selectedRangeLabel: "",
      startDates: _get(dateRangeOptions, "No Date.[0]", moment().toDate()),
      endDates: _get(dateRangeOptions, "No Date.[1]", moment().subtract(1, "days").toDate()),
    };

    this.dateRangeRef = createRef();
  }

  componentDidMount() {
    const { datePickerLabel = "", startDates, endDates, appConstants: { dateRangeOptions, momentDisplayDateFormat }, intl } = this.props;

    let stateData = {
      selectedRangeLabel: (!_isEmpty(datePickerLabel)) ? datePickerLabel : intl.formatMessage({ id: "date_range_picker.default_label", defaultMessage: "date range" })
    };

    if (!_isEmpty(startDates) && !_isEmpty(endDates)) {

      stateData = {
        ...stateData,
        selectedRangeLabel: intl.formatMessage({ id: "date_range_picker.date_range", defaultMessage: "{startDate} - {endDate}" }, {
          startDate: moment(startDates).format(momentDisplayDateFormat), endDate: moment(endDates).format(momentDisplayDateFormat)
        }),
        startDates: !_isEmpty(startDates) ? startDates : _get(dateRangeOptions, "No Date.[0]", moment().toDate()),
        endDates: !_isEmpty(endDates) ? endDates : _get(dateRangeOptions, "No Date.[1]", moment().subtract(1, "days").toDate())
      };
    }

    this.setState(stateData);
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevProps.resetDateRangePicker !== this.props.resetDateRangePicker) && ((this.props.resetDateRangePicker || false) === true)) {
      this._handleReset();
    }

    if (!_isEqual(prevProps.datePickerLabel, this.props.datePickerLabel)) {
      this._handleDatePickeLabelChange();
    }
  }

  _handleDatePickeLabelChange = () => {
    const { appConstants: { dateRangeOptions }, datePickerLabel, intl } = this.props;

    if (datePickerLabel === "No Date") {
      this.setState({
        selectedRangeLabel: intl.formatMessage({ id: "date_range_picker.default_label", defaultMessage: "date range" }),
        startDates: _get(dateRangeOptions, "No Date.[0]", moment().toDate()),
        endDates: _get(dateRangeOptions, "No Date.[1]", moment().subtract(1, "days").toDate())
      });
    }
  }

  _handleReset = () => {
    const { onChange, appConstants: { dateRangeOptions }, intl } = this.props;

    const startDate = _get(dateRangeOptions, "No Date.[0]", moment().toDate());
    const endDate = _get(dateRangeOptions, "No Date.[1]", moment().subtract(1, "days").toDate());

    this.dateRangeRef.current.setStartDate(endDate);
    this.dateRangeRef.current.setEndDate(endDate);
    this.dateRangeRef.current.setStartDate(startDate);

    const picker = (document.getElementsByClassName("daterangepicker")[0] || null);

    if (!_isEmpty(picker)) {
      picker.classList.remove("show-calendar");
    }

    this.setState({
      selectedRangeLabel: intl.formatMessage({ id: "date_range_picker.default_label", defaultMessage: "date range" }),
      startDates: startDate,
      endDates: endDate
    });

    // Callback for props
    if (typeof onChange === "function") {
      onChange(null, null, "No Date");
    }
  }

  _handleUpdateDateRange = (start, end, dtLabel) => {
    const { appConstants: { APIRequestDateFormat, momentDisplayDateFormat }, onChange, intl } = this.props;

    let startDate = null;
    let endDate = null;
    let label = intl.formatMessage({ id: "date_range_picker.default_label", defaultMessage: "date range" });

    let state = {};

    if (dtLabel !== "No Date") {
      startDate = start.format(APIRequestDateFormat);
      endDate = end.format(APIRequestDateFormat);

      state = { ...state, startDates: start, endDates: end };

      label = intl.formatMessage({ id: "date_range_picker.date_range", defaultMessage: "{startDate} - {endDate}" }, {
        startDate: start.format(momentDisplayDateFormat), endDate: end.format(momentDisplayDateFormat)
      });
    }

    state = { ...state, selectedRangeLabel: label };

    // Callback for props
    if (typeof onChange === "function") { onChange(startDate, endDate, dtLabel); }

    if (!_isEmpty(state)) { this.setState(state); }
  }

  render() {
    const { appConstants: { dateRangeOptions }, className } = this.props;
    const { selectedRangeLabel, startDates, endDates } = this.state;

    const truncateClass = (className || "text-truncate");

    return (
      <div className="input-group date-range-picker">
        <div className="form-control text-capitalize-first" onClick={() => this.dateRangeRef.current.ref.click()}>
          <DateRangePickerTmp
            ref={this.dateRangeRef}
            initialSettings={{
              startDate: startDates,
              endDate: endDates,
              ranges: dateRangeOptions,
            }}
            onCallback={this._handleUpdateDateRange}
          >
            <span className={`${(truncateClass || "text-truncate")}`} onClick={(e) => e.stopPropagation()}>{selectedRangeLabel}</span>
          </DateRangePickerTmp>
        </div>

        <span className="input-group-text bg-white waves-effect py-1 d-flex align-items-center border-grey-97 rounded-1 ms-n1">
          <img src={require("../../../assets/icons/icon-date.svg").default} className="img-fluid" alt="img" />
        </span>
      </div>
    )
  }
}

const stateToPropsMapping = (state) => ({
  appConstants: _get(state, "application.constants", {})
});

export default connect(stateToPropsMapping, null)(injectIntl(DateRangePicker));
